// extracted by mini-css-extract-plugin
module.exports = {"searchTakeoverWrapper":"SearchDropdown_searchTakeoverWrapper__wIrNa"};